<template>
<div>
  <v-layout wrap>
    <v-flex md4>
      <h3 class="sub_t p-flex">{{title}}</h3>
    </v-flex>
    <v-flex md8 style="text-align: end;" v-if="!disabled">
      <v-btn color="primary" @click="dialog=true" :disabled="disabled_add_cond">
        <v-icon>search</v-icon>
        <span>Buscar usuario</span>
      </v-btn>
    </v-flex>
  </v-layout>
  <div class="p-flex">
    <v-data-table
			:headers="headers"
			:items="rows"
      disable-pagination
      hide-default-footer
			class="tablaLT1"
      :class="dark_t?'dark':''">

      <template  v-slot:item="props">
        <tr>
          <td>{{props.item.employee_name}}</td>
          <td>{{props.item.position_name}}</td>
          <td>{{props.item.area_name}}</td>
          <td v-if="!disabled">
            <v-icon @click="removeFromList(props.item.id)" style="color:darkred">delete</v-icon>
          </td>
        </tr>

      </template>
			<template v-slot:no-data>
					<v-icon>warning</v-icon>
					Sin Información.
			</template>
		</v-data-table>
    <br>
  </div>
  <v-dialog v-model="dialog" persistent max-width="700">
    <v-card class="pa-20 textAlignCenter">
      <h2>Buscar usuario</h2>
      <br>
      <SimpleCrud
        :headers="headers"
        :name="rq_name"
        :gets_on_created="false"
        :canDetail="false"
        :canAdd="false"
        :canDelete="false">
        <template  slot="filters">
          <v-layout>
            <debounce-select class="px-4" md="6" :name="rq_name" :value.sync="filter.s__username" item_key="username" label="KPT MEL" append_icon="search"/>
            <debounce-select class="px-4" md="6" :name="rq_name" :value.sync="filter.s__employee_name" item_key="employee_name" label="Nombre de trabajador" append_icon="search"/>
          </v-layout>
        </template>
          <template slot-scope="{ item }" slot="action">
            <td><v-icon color="primary" :disabled="items.includes(item.id)" @click="addItem(item)">add</v-icon></td>
          </template>
      </SimpleCrud>
      <v-btn color="secondary" @click="dialog = false">Cerrar</v-btn>

    </v-card>
  </v-dialog>  
</div>
</template>

<script>
import filter from '@/components/mixins/filter';
export default {
  props:['items','disabled','max','item_value', 'title','name'],
  mixins:[filter],
  data() {
    return {
      selectedItem: null,
      rows:[],
      rq_name:'in-table-user',
      dialog:false,
    };
  },
  computed: {
    headers() {
      const hs = [
        { text: 'Nombre', value: 'employee_name'},
        { text: 'Cargo', value: 'position_name'},
        { text: 'Área', value: 'area_name'},
      ]
      if (!this.disabled) hs.push({ text: 'Acción', value: 'action'});
      return hs;
    },
    /* recibe lista de ids y muestra una tabla con esos usuarios */
    disabled_add_cond(){ return this.max? this.items.length >= this.max: false },
  },
  watch:{
    'items':{
      immediate: true,
      handler(v,o) { this.get_rows() },
    },
    'dialog'(v){if(v===true) this.reset();}
  },
  created(){ this.get_rows() },
  methods: {
    get_rows(){
      if (this.items && this.items.length > 0) {
        this.requests.getsSimple['user/a/all']({ae__id:this.items.join(',')})
          .then(r => this.rows = (r || {}).results);
      } else this.rows = [];
    },
    addItem(item){
      this.items.push(item.id);
      this.dialog = false;
    },
    removeFromList(id) { this.items.splice(this.items.indexOf(id), 1) },
    reset(){
      this.filter.s__employee_name = null;
      this.filter.s__username = null;
      this.myRequestStatus.status = false;
      this.myRequestStatus.ticking = false;
      this.requests.gets[`${this.rq_name}/a/all`]()
    },
  }
};
</script>
